import { Client,Account } from "appwrite";


const PROJECT_ID = '67664784003af3a2b66d'
const ENDPOINT = 'https://cloud.appwrite.io/v1';



const client = new Client()
    .setEndpoint(ENDPOINT)
    .setProject(PROJECT_ID);

export const account = new Account(client)


export default client;



